module.exports = __webpack_public_path__ + "media/brands/piaggio-4a5f786d.png";